<template>
  <div style="margin-right: 3%">
    <h1 v-bg-typography="'h1'" :style="{ marginTop: '10px' }">Heatmaps</h1>
    <div class="participant-tabs">
      <h2
        :class="this.activeTab === 'heatmaps' ? 'active' : ''"
        @click="changeTab('heatmaps')"
      >
        Heatmaps
      </h2>
      <h2
        :class="this.activeTab === 'setup' ? 'active' : ''"
        @click="changeTab('setup')"
      >
        Manage
      </h2>
    </div>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>

    <div class="select" v-if="this.activeTab === 'heatmaps' && !isLoading">
      <bg-field name="heatmap" label="Page" style="max-width: 250px">
        <bg-select
          placeholder="Select a page"
          :options="pages"
          label="name"
          :value="selectedHeatmap"
          @change="onPageChange"
        ></bg-select>
      </bg-field>
      <bg-field name="heatmap" label="First x seconds" style="max-width: 175px">
        <bg-select
          :options="showOptions"
          label="title"
          :value="showOption"
          @change="onShowChange"
        ></bg-select>
      </bg-field>
      <bg-field name="heatmap" label="Participant" style="max-width: 175px">
        <bg-select
          :options="participants"
          label="id"
          :value="selectedPp"
          @change="onPpChange"
        ></bg-select>
      </bg-field>
      <bg-field
        name="heatmap"
        label="Upload screenshot"
        style="max-width: 175px"
      >
        <div class="selector">
          <!-- SAVE FOR LATER! 
                    <div 
                    :class="this.type === 'eye' ? 'active-type' : ''"
                    class="selector-item" 
                    @click="type = 'eye'"
                    >
                        <bg-icon name="fview"></bg-icon>
                    </div>
                    <div :class="this.type === 'mouse' ? 'active-type' : ''" class="selector-item" @click="type = 'mouse'">
                        <bg-icon name="fmouse"></bg-icon>
                    </div>
                    -->
          <div class="button" id="upload">
            <bg-icon name="fupload"></bg-icon>
            <input
              ref="imageRef"
              type="file"
              @change="onFileChange"
              accept="image/*"
              style="
                opacity: 0;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
              "
            />
          </div>
        </div>
      </bg-field>
    </div>
    <transition name="fade">
      <Heatmap
        :data="data"
        :participants="participants"
        :type="type"
        :showFirst="showOption"
        :showPp="selectedPp"
        :selected="selectedHeatmap"
        :heightCorrection="heightCorrection"
        v-show="!isLoading && this.activeTab === 'heatmaps'"
        @onSelectBox="selectBox"
        @loading="getLoadingStatus"
        @participants="getParticipants"
        :key="rerenderKey"
      />
    </transition>
    <transition name="slide-fade">
      <div
        class="bottom-container"
        v-if="
          this.activeTab === 'heatmaps' &&
          this.selectedHeatmap &&
          !this.isLoading
        "
      >
        <div class="icon">
          <img src="./eyebox.svg" alt="" />
        </div>
        <div class="box-item">
          <p class="item-title">Percentage of fixations</p>
          <p class="item-subtitle">{{ boxCalculations.fixations }}</p>
        </div>
        <div class="box-item">
          <p class="item-title">Participants visited</p>
          <p class="item-subtitle">{{ boxCalculations.participants }}</p>
        </div>
        <div class="box-item">
          <p class="item-title">Time to first focus (ms)</p>
          <p class="item-subtitle">{{ boxCalculations.ttff }}</p>
        </div>
      </div>
    </transition>
    <div class="setup-container" v-if="this.activeTab === 'setup'">
      <div class="create" v-if="!isLoading">
        <bg-field style="max-width: 235px" label="Add page name" name="title">
          <bg-input
            height="46px"
            width="50"
            id="input-title"
            placeholder="Give a name"
            v-model="newHeatmap.name"
          />
        </bg-field>
        <bg-field label="Add URL" name="url">
          <bg-input
            height="46px"
            name="url"
            placeholder="Input URL"
            v-model="newHeatmap.url"
          />
        </bg-field>
        <bg-field
          info="Exact match targets a specific URL, including the protocol, which can include a query string and fragment"
          style="max-width: 255px"
          label="URL match type"
          name="email"
        >
          <bg-select
            :options="matchOptions"
            placeholder="Select a match criterium"
            :value="newHeatmap.match_type"
            @change="onMatchChange"
          ></bg-select>
        </bg-field>
        <div class="button" id="add" @click="addUrl">
          <bg-icon name="fplus"></bg-icon>
        </div>
      </div>
      <List
        v-if="!isLoading"
        v-show="this.pages.length > 0"
        :headers="list.headers"
        :values="list.values"
        :actions="list.actions"
        :data="pages"
        :fractions="list.fractions"
        @change="getChanges"
      />
    </div>
    <bg-modal
      v-if="isModalOpen"
      body="Are you sure you want to remove this Heatmap?"
      @close="isModalOpen = false"
    >
      <bg-button
        variant="secondary"
        text="Cancel"
        @click="isModalOpen = false"
      />
      <bg-button
        variant="destructive"
        class="action"
        text="Delete"
        @click="deleteHeatmap"
      />
    </bg-modal>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";

.bottom-container {
  background-color: #636383;
  position: fixed;
  bottom: 0;
  left: 269px;
  height: 110px;
  width: -webkit-calc(100% - 269px);
  width: -moz-calc(100% - 269px);
  width: calc(100% - 269px);
  box-shadow: 0px -5px 4px rgba(11, 11, 61, 0.2);
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr;
  justify-items: center;
  align-items: center;
  padding: 0 10%;
  z-index: 10000;

  .item-title {
    color: white;
    font-size: 10pt;
    line-height: 20pt;
  }

  .item-subtitle {
    color: white;
    font-size: 14pt;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
}
</style>

<script>
import Heatmap from "@/components/heatmap";
import BgTypography from "@/directives/bg-typography";
import BgLoader from "@/components/bg-loader";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgSelect from "@/components/bg-select";
import List from "@/components/list";
import BgIcon from "@/components/bg-icon";
import BgButton from "@/components/bg-button";
import Urlbox from "urlbox";
import API from "@/api";
import BgModal from "@/components/bg-modal";

export default {
  components: {
    Heatmap,
    BgLoader,
    BgField,
    BgInput,
    BgSelect,
    List,
    BgButton,
    BgIcon,
    BgModal,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      activeTab: "heatmaps",
      activeHeatmapId: null,
      boxCalculations: {
        ttff: "-",
        participants: "-",
        fixations: "-",
      },
      data: [],
      deleteHeatmapId: {},
      fakeData: [],
      heatmaps: [],
      heightCorrection: 292,
      isLoading: false,
      isModalOpen: false,
      list: {
        headers: ["Name", "URL", "Match"],
        actions: ["Delete"],
        fractions: [1, 2, 1],
        values: ["name", "url", "match_type"],
        listdata: [],
      },
      matchOptions: ["Exact match", "Starts with"],
      mice: [],
      newHeatmap: {
        name: "",
        url: "",
        match_type: "",
        screenshot: {
          url: "",
        },
      },
      participants: ["All"],
      rerenderKey: 0,
      selectedHeatmap: null,
      selectedPp: "All",
      showOption: "All",
      showOptions: ["All", 1, 2, 5, 10, 20, 30, 60],
      type: "eye",
      pages: [],
    };
  },
  created() {
    this.fetchData();
  },
  watch: {
    selectedHeatmap: function (val) {
      this.data = val.data;
    },
  },
  methods: {
    async addUrl() {
      this.isLoading = true;
      // 1 fetch screenshot, add it to heatmap
      const urlbox = Urlbox(
        "8wII7dOU3EGNmOFr",
        "ebcd185c3d2f49b198a257624c141416"
      );
      const options = {
        format: "png",
        click_accept: true,
        hide_cookie_banners: true,
        cookie: ["cookie=OptIn=true"],
        url: this.newHeatmap.url,
        full_page: true,
        height: "1080",
        width: "1920",
      };
      const screenshot = await urlbox.buildUrl(options);

      function toDataURL(url) {
        return new Promise((resolve, reject) => {
          var xhr = new XMLHttpRequest();
          xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(xhr.response);
          };
          xhr.open("GET", url);
          xhr.responseType = "blob";
          xhr.send();
        });
      }
      const fileBase64 = await toDataURL(screenshot);
      this.newHeatmap.screenshot = fileBase64;

      // 2 update heatmaps in backend
      const res = await API.test.createHeatmap(
        this.$route.params.id,
        this.newHeatmap
      );

      // 3 add it to page options
      this.fetchData();

      //4 empty newHeatmap input fields
      this.newHeatmap = {
        name: "",
        url: "",
        match_type: "",
        screenshot: {
          url: "",
        },
      };
      this.isLoading = false;
    },
    changeTab(tabName) {
      this.selectedPp = "All";
      this.showOption = "All";
      this.activeTab = tabName;
    },
    async deleteHeatmap() {
      this.isLoading = true;
      const index = this.pages.findIndex(
        (el) => el.id === this.deleteHeatmapId.item.id
      );
      this.pages.splice(index, 1);
      this.heatmaps.splice(index, 1);
      if (this.selectedHeatmap.id === this.deleteHeatmapId.item.id) {
        this.selectedHeatmap = {};
      }
      const del = await API.test.deleteHeatmap(
        this.$route.params.id,
        this.deleteHeatmapId.item.id
      );
      this.isModalOpen = false;
      this.isLoading = false;
    },
    async fetchData() {
      this.isLoading = true;
      this.pages = [];
      this.heatmaps = [];

      const testId = this.$route.params.id;
      const res = await API.test.getTest(testId);

      res.heatmaps.forEach((el, i) => {
        this.heatmaps.push(el);
        this.heatmaps[i].data = [];
      });

      res.heatmaps.forEach((el, i) => {
        this.pages.push(el);
        res.participants.forEach(async (pp) => {
          this.participants.push(pp);
          const ppData = await API.test.getParticipant(testId, pp.id);
          const result = await this.getStartAndEnd(ppData, el);
          const filtered = await this.filterPageData(result, pp.id);
          filtered.forEach((el) => {
            this.heatmaps[i].data.push(el);
          });
          // console.debug('Processed Participant: ' + pp.id)
        });
        // console.debug("processed heatmap with index: " + i);
      });

      if (this.pages.length > 0) {
        if (this.activeHeatmapId) {
          this.selectedHeatmap = this.pages.find(
            (el) => el.id === this.activeHeatmapId
          );
          this.activeHeatmapId = null;
        } else {
          this.selectedHeatmap = this.pages[0];
        }
      } else {
        this.activeTab = "setup";
      }
      const vm = this;
      setTimeout(function () {
        vm.isLoading = false;
      }, 3000);
    },
    filterPageData(result, ppId) {
      const vm = this;
      let filtered = [];
      return new Promise((resolve) => {
        let previousX = 0;
        let previousY = 0;
        let previous2X = 0;
        let previous2Y = 0;

        result.eyes.forEach(function (eye) {
          result.times.forEach((time) => {
            if (
              eye.timestamp < time.end &&
              eye.timestamp > time.start &&
              eye.y < 1080 &&
              eye.x < 1920
            ) {
              let diff2X = eye.x - previous2X;
              if (diff2X < 0) {
                diff2X = diff2X * -1;
              }
              let diff2Y = eye.y - previous2Y;
              if (diff2Y < 0) {
                diff2Y = diff2Y * -1;
              }

              let diffX = eye.x - previousX;
              if (diffX < 0) {
                diffX = diffX * -1;
              }
              let diffY = eye.y - previousY;
              if (diffY < 0) {
                diffY = diffY * -1;
              }

              let delta = 15;

              let fixation =
                diffX < delta &&
                diffY < delta &&
                diff2X < delta &&
                diff2Y < delta;

              let closest = result.mice.reduce(function (prev, curr) {
                return Math.abs(curr.timestamp - eye.timestamp) <
                  Math.abs(prev.timestamp - eye.timestamp)
                  ? curr
                  : prev;
              });

              let value = 1;
              if (fixation) {
                value = 15;
              }

              let eyeY;
              let mouseY;
              if (closest.scroll_y > 1) {
                eyeY = closest.scroll_y + eye.y;
                mouseY = closest.scroll_y + closest.y;
              } else {
                eyeY = eye.y;
                mouseY = closest.y;
              }

              filtered.push({
                x: eye.x,
                y: eyeY,
                value: value,
                pp: ppId,
                scroll: closest.scroll_y,
                url: closest.url,
                click: closest.click,
                xMouse: closest.x,
                yMouse: mouseY,
                start: time.start,
                end: time.end,
                timestamp: eye.timestamp,
                fixation: fixation,
              });

              previous2X = previousX;
              previous2Y = previousY;

              previousX = eye.x;
              previousY = eye.y;
            }
          });
        });
        resolve(filtered);
      });
    },
    async getChanges(val) {
      if (val.action === "Select") {
        this.selectedHeatmap = val.item;
        this.activeTab = "heatmaps";
      } else if (val.action === "Delete") {
        this.deleteHeatmapId = val;
        this.isModalOpen = true;
      }
    },
    getLoadingStatus(val) {
      this.isLoading = val;
    },
    getParticipants(val) {
      this.participants = ["All"];
      val.forEach((el) => this.participants.push(el));
    },
    getStartAndEnd(data, heatmap) {
      return new Promise((resolve) => {
        let times = [];
        let section = {};
        let tempMice = [];

        data.mice.forEach((element) => {
          const url = decodeURIComponent(element.url);
          if (heatmap.match_type === "Exact match") {
            if (url === heatmap.url) {
              if (!section.start) {
                section.start = element.timestamp;
                section.end = element.timestamp;
              } else if (element.timestamp < section.start) {
                section.start = element.timestamp;
              } else if (element.timestamp > section.end) {
                if (element.timestamp - section.end > 1000) {
                  times.push(section);
                  section = {};
                } else {
                  section.end = element.timestamp;
                }
              }
            }
          } else if (heatmap.match_type === "Starts with") {
            if (url.startsWith(heatmap.url)) {
              if (!section.start) {
                section.start = element.timestamp;
                section.end = element.timestamp;
              } else if (element.timestamp < section.start) {
                section.start = element.timestamp;
              } else if (element.timestamp > section.end) {
                if (element.timestamp - section.end > 1000) {
                  times.push(section);
                  section = {};
                } else {
                  section.end = element.timestamp;
                }
              }
            }
          }
        });
        times.push(section);

        data.mice.forEach((element) => {
          times.forEach((time) => {
            if (
              element.timestamp < time.end &&
              element.timestamp > time.start
            ) {
              tempMice.push({
                x: element.x,
                y: element.y,
                url: element.url,
                timestamp: element.timestamp,
                scroll_y: element.scroll_y,
                page_height: element.page_height,
                click: element.click,
                pp: element.participant_id,
                value: 80,
                start: section.start,
              });
            }
          });
        });

        resolve({
          times: times,
          mice: tempMice,
          eyes: data.eyes,
          heatmap: heatmap,
        });
      });
    },
    async onFileChange() {
      this.activeHeatmapId = this.selectedHeatmap.id;
      const file = await this.toBase64(this.$refs.imageRef.files[0]);
      this.selectedHeatmap.screenshot = file;
      await API.test.updateHeatmap(
        this.$route.params.id,
        this.selectedHeatmap
      );
      this.fetchData();
      this.rerenderKey = this.rerenderKey + 1;
    },
    onPageChange(val) {
      this.selectedHeatmap = val;
      this.rerenderKey = this.rerenderKey + 1;
    },
    onMatchChange(val) {
      this.newHeatmap.match_type = val;
    },
    onPpChange(val) {
      this.selectedPp = val;
      // this.rerenderKey = (this.rerenderKey + 1)
    },
    onShowChange(val) {
      this.showOption = val;
      // this.rerenderKey = (this.rerenderKey + 1)
    },
    selectBox(ttff, participants, fixations) {
      this.boxCalculations.ttff = ttff;
      this.boxCalculations.participants = participants;
      this.boxCalculations.fixations = fixations;
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
  },
};
</script>
